module.exports = {
  title: '共创家—社区后台管理',
  baseUrl: 'http://cbo1.jifenxitong.com/', // 测试项目地址
  baseApi: 'https://applet1.jifenxitong.com/cbo', // 测试api请求地址
  APPID: 'wx489c93ebee8842f2',
  APPSECRET: '',
  $cdn: 'https://hyjy-oss.oss-cn-chengdu.aliyuncs.com/mp/assets/'
}
